const LocationServiceState = Object.freeze({
  Active: '0',
  Inactive: '1',
});

export default LocationServiceState;
